export default __webpack_public_path__ + "static/media/screen16.9fe44210.svg";